import React from 'react';
import { Facebook, Instagram, Linkedin, X, Youtube } from 'lucide-react';

const FooterPremium = () => {
  const footerSections = [
    {
      title: 'INTELLIGENCE',
      links: [
        { label: 'Equity Intelligence™', href: '/equity-intelligence' },
        { label: 'Sector Intelligence™', href: '/sector-intelligence' },
        { label: 'Legal Intelligence™', href: '/legal-intelligence' },
        { label: 'Professional Intelligence™', href: '/professional-intelligence' },
        { label: 'Civil Services Intelligence™', href: '/civil-services-intelligence' }
      ]
    },
    {
      title: 'COMPANY',
      links: [
        { label: 'About Us', href: '/about' },
        { label: 'Subscription', href: '/subscription' },
        { label: 'Contact', href: '/contact' }
      ]
    },
    {
      title: 'LEGAL',
      links: [
        { label: 'Terms & Conditions', href: '/terms' },
        { label: 'Privacy Policy', href: '/privacy' },
        { label: 'Refund Policy', href: '/refund' },
        { label: 'Cancellation Policy', href: '/cancellation' },
        { label: 'Disclaimer', href: '/disclaimer' }
      ]
    }
  ];

  return (
    <footer 
      className="border-t border-slate-200 bg-slate-50 py-10 px-6 text-slate-900 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-100 md:px-12 lg:px-24"
      data-testid="premium-footer"
    >
      <div className="max-w-7xl mx-auto">
        {/* Top Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-8 mb-8">
          {/* Logo Column */}
          <div className="col-span-2 md:col-span-1">
            <a href="/" className="mb-3 inline-block text-lg font-semibold tracking-[0.2em] text-slate-950 dark:text-white">
              THE B TREE
            </a>
            <p className="max-w-[220px] text-xs leading-5 text-slate-600 dark:text-slate-400">
              Institutional-quality intelligence for investors, professionals and decision-makers.
            </p>
          </div>

          {/* Footer Sections */}
          {footerSections.map((section, index) => (
            <div key={index}>
              <h4 className="mb-3 text-[11px] font-bold tracking-[0.18em] text-slate-900 dark:text-slate-200">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a 
                      href={link.href}
                      className="text-xs leading-5 text-slate-600 transition-colors hover:text-slate-900 dark:text-slate-400 dark:hover:text-white"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="mb-5 h-px bg-slate-200 dark:bg-slate-800"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="space-y-1 text-xs text-slate-600 dark:text-slate-400">
            <p>© 2026 The B Tree. All rights reserved.</p>
            <p>Information and education only. Not investment, legal, tax or professional advice.</p>
          </div>
          
          {/* Social Links */}
          <div className="flex items-center gap-4">
            {[
              { label: 'LinkedIn', href: 'https://www.linkedin.com/company/the-b-tree/about/?viewAsMember=true', icon: Linkedin },
              { label: 'Instagram', href: 'https://www.instagram.com/thebtree.in/', icon: Instagram },
              { label: 'X', href: 'https://x.com/theBtree_x', icon: X },
              { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61591460311432', icon: Facebook },
              { label: 'YouTube', href: 'https://www.youtube.com/@TheBTreelearn', icon: Youtube },
            ].map(({ label, href, icon: Icon }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition-colors hover:border-slate-300 hover:text-slate-950 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-slate-500 dark:hover:text-white" aria-label={label}>
                <Icon className="h-5 w-5" strokeWidth={label === 'X' ? 2.75 : 2} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterPremium;
